export { ManagedUserProfileTabs } from './ManagedUserProfileTabs';

